import axios from '@/zenky'

export default {
  namespaced: true,

  state: {
    categories: {
      loaded: false,
      list: [],
    },
  },

  getters: {
    categoriesLoaded(state) {
      return state.categories.loaded
    },

    categories(state) {
      return state.categories.list
    },
  },

  mutations: {
    setCategories(state, categories) {
      state.categories.loaded = true
      state.categories.list = categories
    },
  },

  actions: {
    async loadCategories({ commit, getters }) {
      if (getters.categoriesLoaded) {
        return getters.categories
      }

      const categories = (await axios.get('article-categories')).data.data

      commit('setCategories', categories)

      return categories
    },
  },
}
